module.exports = __webpack_public_path__ + "img/06.0abe52c0.png";